// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.PDP.View'
,	[
	'c3_shoppingextensions_pdp.tpl'
	
	,	'C3.ShoppingExtensions.PDP.Model'
	,   'AjaxRequestsKiller'
	/*,   'C3.ShoppingExtensions.PDP.CrossSellItems.View'*/
	,   'C3.ShoppingExtensions.PDP.CrossSellItems.MainView'
	/*,   'C3.ShoppingExtensions.PDP.SetsIncluded.Item.View'*/
	,   'C3.ShoppingExtensions.PDP.SetsIncluded.Item.MainView'
	,   'C3.ShoppingExtensions.PDP.MediaTab.View'
	
	,	'Backbone'
	,   'Utils'
	,   'C3.ShoppingExtensions.Resources.Macro.View'
	,   'resources_cell_view.tpl'
	,   'C3.ShoppingExtensions.Media.Macro.View'
	,   'media_cell_view.tpl'
	,   'Backbone.CollectionView'
	,   'backbone_collection_view_row.tpl'
	,   'C3.ShoppingExtensions.PDP.RecentlyViewed.MainView'
    ]
, function (
	c3_shoppingextensions_pdp_tpl
	
	,	PDPModel
	,   AjaxRequestsKiller
	/*,   CrossSellItemsView*/
	,   CrossSellItemsMainView
	/*,   SetsIncludedItemView*/
	,   SetsIncludedItemMainView
	,   MediaTabView
	
	,	Backbone
	,   Utils
	,   ResourcesMacroView
	,   resources_cell_view_tpl
	,   MediaMacroView
	,   media_cell_view_tpl
	,   BackboneCollectionView
	,   backbone_collection_view_row_tpl
	,   PDPRecentlyViewed
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_pdp_tpl

	,	initialize: function (options) {
			this.application = options.application;
			this.layout = options.layout;
			this.iteminfo = options.iteminfo;
			this.configuration = options.configuration;
			this.container = options.container;
			
			var configuration = this.configuration;
			this.pdpConfig = configuration.PDP.config;

			var iteminfo = this.iteminfo
			,   item = iteminfo.item
			,   spec_item_fields = []

			var obj = this.pdpConfig;

			_.each(obj,function(confg){
			    for (var key in item) 
			    {		      
			      if(key == confg.fieldid)
			      {
			      	//console.log(item[key])
			      	if(item[key] !== '')
			      	spec_item_fields.push({
			      		label : confg.fieldlabel,
			      		value : item[key],
			      		isPhoneDevice :Utils.isPhoneDevice()
			      	});
			      }
			    }
			});
			this.specificationItemFields = spec_item_fields;

			if(Utils.isPhoneDevice()){
				this.on('afterViewRender', this.loadTabFunctionalities, this);
			}
			
		}


	,  render: function()
	{	
		var self = this;
		
		var item_info = this.iteminfo
		,   item = item_info.item
		,   itemtype = item.itemtype
		,   item_id = item.internalid

		var model = new PDPModel();

		model.fetch({
			data: {
                itemid: item_id,
                itemtype : itemtype
            },
            killerId: AjaxRequestsKiller.getKillerId()
		}).done(function (res)
	      {
	      //console.log(res)

	      	//Sets Include section
	      	var itemComponents = res.itemComponentsData;
	      	var itemComponentsDataArray = []

	      	_.each(itemComponents,function(comp){
	      		if(comp.isonline == "T" && comp.custitem_display_in_aams == "T")
	      			itemComponentsDataArray[itemComponentsDataArray.length] = comp.internalid
	      	});

	      	self.itemComponentsData = itemComponentsDataArray;


	      	//Components Tab for Kit items
	      	var kitItemComponentsDataArray = []
	      	if(itemtype == 'Kit')
	      	{
	      		var kitItemComponents = res.kitItemComponentsData;

	      		_.each(kitItemComponents,function(comp){
		      		if(comp.isonline == "T" && comp.custitem_display_in_aams == "T")
		      			kitItemComponentsDataArray[kitItemComponentsDataArray.length] = comp
		      	});
		      	self.kitItemComponentsData = kitItemComponentsDataArray;
	      	}

	      	//Crosell items section
	      	var crosssellitems = res.itemcrosssell[0];
	      //	console.log(crosssellitems.length)
	      	if(crosssellitems && crosssellitems.length > 0)
	      	self.crosssellitems = crosssellitems;
	      	//crosssellitems = crosssellitems.split(',');

	      	self.crosssellitems = crosssellitems;
	      	self.resourcesData = res.itemresources[0];

	      	//Kit up functionality section
	      	/*var kitUpItemsData = res.kitUpItemsFunctionalityData;
	      	self.kitupitems = kitUpItemsData;*/
	      	
	      	self._render();     	
	      })
	}		

	,	events: {
		'click [data-action="show-video-in-popup"]':'showVideoInPopup',
		'click [data-action="download-inventory"]':'downloadInventory',
		'click [data-action="take-to-inventory-page"]':'takeToViewInventoryPage',
		'click [data-action="show-nexttab"]':'showNextTab',
		'click [data-action="show-pretab"]':'showPrevTab',
		'click [data-action="selected-tab"]':'moveTab',
		'click [data-action="view-more-content-from-tab"]':'viewMoreContent',
		'click [data-action="show-all-resources"]':'showAllResourcesMobile',
		'click [data-action="show-all-media"]':'showAllMediaMobile'
		}

	,	bindings: {
		}

	, 	childViews: {
			'Cross.Sell.Items': function() {
				var crosssellitems = this.crosssellitems;
				var self = this;

				return new CrossSellItemsMainView({
			          itemsIds: crosssellitems,
			          application: self.application,
			          configuration : self.configuration,
			          container : self.container		        
			        });

				//console.log(crosssellitems)
				//`con`sole.log(crosssellitems)
				/*return new CrossSellItemsView({
			          itemsIds: crosssellitems,
			          application: self.application,
			          configuration : self.configuration,
			          container : self.container		        
			        });*/
        	},
        	'Sets.Incuded.Item': function() {
				var itemComponents = this.itemComponentsData;
				var self = this;

				return new SetsIncludedItemMainView({
			          itemsIds: itemComponents,
			          application: self.application,
			          configuration : self.configuration,
			          container : self.container		        
			        });
				/*return new SetsIncludedItemView({
			          itemsIds: itemComponents,
			          application: self.application,
			          configuration : self.configuration,
			          container : self.container		        
			        });*/
        	},

        	'Resources.Content': function(){
        		//console.log(this.resourcesArray)
        		var self = this;
        		var resourcesArrayData = this.resourcesArray;

        		var viewsPerRowItems = 6;

            	if(Utils.isPhoneDevice())
            		viewsPerRowItems = 2;

        		return new BackboneCollectionView({
	                collection: resourcesArrayData ? resourcesArrayData : [],
	                childView: ResourcesMacroView,
	                viewsPerRow: viewsPerRowItems,
	                cellTemplate: resources_cell_view_tpl,
	                rowTemplate: backbone_collection_view_row_tpl,
	                childViewOptions: {
	                    application: self.application
	                }
	            });
        	},

        	'Media.Content': function(){
        		//console.log(this.resourcesArray)
        		var self = this;
        		var mediaArrayData = this.mediaArray;

        		var viewsPerRowItems = 4;

            	if(Utils.isPhoneDevice())
            		viewsPerRowItems = 2;

        		return new BackboneCollectionView({
	                collection: mediaArrayData ? mediaArrayData : [],
	                childView: MediaMacroView,
	                viewsPerRow: viewsPerRowItems,
	                cellTemplate: media_cell_view_tpl,
	                rowTemplate: backbone_collection_view_row_tpl,
	                childViewOptions: {
	                    application: self.application
	                }
	            });
        	},

        	'PDP.RecentlyViewed.Main': function(){
        		return new PDPRecentlyViewed({		          
			          application: this.application,
			          configuration : this.configuration,
			          container : this.container        
			        });
        	}
		}

	, loadTabFunctionalities: function loadTabFunctionalities()
	{
		//console.log('loadTabFunctionalities')
		var item_info = this.iteminfo
		,   resourcesArray =  []
		,   item = item_info.item
		,   product_group = item.custitemproduct_category
		,   featured_desc = item.featureddescription

		//console.log(featured_desc.length)
		if(featured_desc && featured_desc.length > 376)
		{
		  $('.desc-tab-more .view-more').css('display','block')
		  $('#product-details-information-tab-content-container-1').css('height','90px');
		  $('#product-details-information-tab-content-container-1').css('overflow','hidden');
		}
		else{
		  $('.desc-tab-more .view-more').css('display','none')  
		}

		/*var specificationFields = this.specificationItemFields
		,   showLessSpecfications = specificationFields && specificationFields.length > 4 ? true : false
				
		console.log(specificationFields)
		if(showLessSpecfications == true || showLessSpecfications == 'true')
		{
		 $('.specific-tab-more .view-more').css('display','block');
		 $('.specs-list').css('height','113px');
		 $('.specs-list').css('overflow','hidden');
		}
		else{
		$('.specific-tab-more .view-more').css('display','none');
		
		}*/

	}	

	,  moveTab:  function moveTab(){

		/*setTimeout(function(){
		    		
			var $Categoryscroller = $('.pdp-tabs');
			var findEleActiveCat =  $Categoryscroller.find('.active');
			if(findEleActiveCat.length > 0)
			{
				var dataIndexCat = findEleActiveCat.attr('data-index')
				//console.log(dataIndexCat)
				var goToCat = $('#tab-index-'+dataIndexCat).position().left;
				//console.log(goToCat)
				if(findEleActiveCat.hasClass('index-0'))
					goToCat = goToCat-13;
				$Categoryscroller.animate({'scrollLeft': goToCat}, 500);
			}

		}, 500);*/	
	  }

	,  showAllResourcesMobile: function showAllResourcesMobile(e)
		{
			var anchor = jQuery(e.currentTarget)
			,   data_param = anchor.attr('data-parameter');

			var parentEle = $('.Resources-Content')
			,   children = parentEle.children()
			,   children_length = children.length;

			if(data_param == 'show-more'){
				children.removeClass("hide-these-sections");
				$('.see-less-link-pdp-resources').css('display','block');
				$('.see-all-link-pdp-resources').css('display','none');
			}
			else if (data_param == 'show-less'){				
				children.addClass("hide-these-sections");
				var firstChild = children.first();
				var secondChild = children.first().next();
				if(children_length == 2){
                  firstChild.removeClass('hide-these-sections')
                  //secondChild.removeClass('hide-these-sections')
                }
                else{
                firstChild.removeClass('hide-these-sections')
                secondChild.removeClass('hide-these-sections')
                 }
				/*firstChild.removeClass('hide-these-sections')
				secondChild.removeClass('hide-these-sections')*/

				$('.see-less-link-pdp-resources').css('display','none');
				$('.see-all-link-pdp-resources').css('display','block');
			}
		}  

	,  showAllMediaMobile: function showAllMediaMobile(e)
		{
			var anchor = jQuery(e.currentTarget)
			,   data_param = anchor.attr('data-parameter');

			var parentEle = $('.Media-Content')
			,   children = parentEle.children()
			,   children_length = children.length;

			if(data_param == 'show-more'){
				children.removeClass("hide-these-sections");
				$('.see-less-link-pdp-media').css('display','block');
				$('.see-all-link-pdp-media').css('display','none');
			}
			else if (data_param == 'show-less'){				
				children.addClass("hide-these-sections");
				var firstChild = children.first();
				//var secondChild = children.first().next();
				firstChild.removeClass('hide-these-sections')
				//secondChild.removeClass('hide-these-sections')

				$('.see-less-link-pdp-media').css('display','none');
				$('.see-all-link-pdp-media').css('display','block');
			}
		}  	

	,  viewMoreContent:  function viewMoreContent(e){

			var targetElement = $(e.currentTarget)
			,   clicked_origin = targetElement.attr('data-clicked')

			//console.log(clicked_origin) 
			if(clicked_origin == 'description')
			{
			 	if($('#product-details-information-tab-content-container-1').hasClass('open'))
				{
					$('#product-details-information-tab-content-container-1').removeClass('open'); 
					$('#product-details-information-tab-content-container-1').css('height','90px');
					$('#product-details-information-tab-content-container-1').css('overflow','hidden');
					$('.desc-tab-more .view-less-minus-icon').css('display','none')
					$('.desc-tab-more .view-more-plus-icon').css('display','block')
					//$('.plus-icon .view-m-s').text('View More');
				}
				else{
					$('#product-details-information-tab-content-container-1').slideDown(300).addClass('open'); 
					$('#product-details-information-tab-content-container-1').css('height','auto');
					$('#product-details-information-tab-content-container-1').css('overflow','auto');
					$('.desc-tab-more .view-less-minus-icon').css('display','block')
					$('.desc-tab-more .view-more-plus-icon').css('display','none')
					//$('.plus-icon .view-m-s').text('View Less');
				}
			}
			else if(clicked_origin == 'specifications')
			{

				if($('.specs-list').hasClass('open'))
				{
					$('.specs-list').removeClass('open'); 
					$('.specs-list').css('height','113px');
					$('.specs-list').css('overflow','hidden');
					$('.specific-tab-more .view-less-minus-icon').css('display','none')
					$('.specific-tab-more .view-more-plus-icon').css('display','block')
					//$('.plus-icon .view-m-s').text('View More');
				}
				else{
					$('.specs-list').slideDown(300).addClass('open'); 
					$('.specs-list').css('height','auto');
					$('.specs-list').css('overflow','auto');
					$('.specific-tab-more .view-less-minus-icon').css('display','block')
					$('.specific-tab-more .view-more-plus-icon').css('display','none')
					//$('.plus-icon .view-m-s').text('View Less');
				}
			}
			else if(clicked_origin == 'documents')
			{
				if($('.docs').hasClass('open'))
				{
					$('.docs').removeClass('open'); 
					$('.docs').css('height','185px');
					$('.docs').css('overflow','hidden');
					$('.documents-tab-more .view-less-minus-icon').css('display','none')
					$('.documents-tab-more .view-more-plus-icon').css('display','block')
					//$('.plus-icon .view-m-s').text('View More');
				}
				else{
					$('.docs').slideDown(300).addClass('open'); 
					$('.docs').css('height','auto');
					$('.docs').css('overflow','auto');
					$('.documents-tab-more .view-less-minus-icon').css('display','block')
					$('.documents-tab-more .view-more-plus-icon').css('display','none')
					//$('.plus-icon .view-m-s').text('View Less');
				}
			}
			else if(clicked_origin == 'media')
			{
				if($('.media').hasClass('open'))
				{
					$('.media').removeClass('open'); 
					$('.media').css('height','250px');
					$('.media').css('overflow','hidden');
					$('.media-tab-more .view-less-minus-icon').css('display','none')
					$('.media-tab-more .view-more-plus-icon').css('display','block')
					//$('.plus-icon .view-m-s').text('View More');
				}
				else{
					$('.media').slideDown(300).addClass('open'); 
					$('.media').css('height','auto');
					$('.media').css('overflow','auto');
					$('.media-tab-more .view-less-minus-icon').css('display','block')
					$('.media-tab-more .view-more-plus-icon').css('display','none')
					//$('.plus-icon .view-m-s').text('View Less');
				}
			}
			else if(clicked_origin == 'kitcomponents')
			{
				if($('.kit-component-table').hasClass('open'))
				{
					$('.kit-component-table').removeClass('open'); 
					$('.kit-component-table').css('height','195px');
					$('.kit-component-table').css('overflow','hidden');
					$('.kit-tab-more .view-less-minus-icon').css('display','none')
					$('.kit-tab-more .view-more-plus-icon').css('display','block')
					//$('.plus-icon .view-m-s').text('View More');
				}
				else{
					$('.kit-component-table').slideDown(300).addClass('open'); 
					$('.kit-component-table').css('height','auto');
					$('.kit-component-table').css('overflow','auto');
					$('.kit-tab-more .view-less-minus-icon').css('display','block')
					$('.kit-tab-more .view-more-plus-icon').css('display','none')
					//$('.plus-icon .view-m-s').text('View Less');
				}
			}
	    }    

	,  showNextTab:  function showNextTab(){
		 $('.show-less').show();
		 $('.pdp-tabs').css('margin-left','10px')
		  $('.pdp-tabs').animate({
		    scrollLeft: "+=200px"
		  }, "slow");
	    }    

	,   showPrevTab: function showPrevTab(){
			$('.pdp-tabs').animate({
		    	scrollLeft: "-=200px"
		 	 }, "slow");
		}    

	,  showVideoInPopup: function showVideoInPopup(e){
			
			var targetEle = $(e.currentTarget)
			,   sibling = targetEle.siblings()
			,   siblingSrc = sibling.attr('src');

			var layout = this.layout;

			var mediaVew = new MediaTabView({
				siblingSrc : siblingSrc,
				application : this.application
			})
		    layout.showContent(mediaVew, {showInModal: true})
		}	

	,   downloadInventory: function downloadInventory(e){
			var targetElement = $(e.currentTarget)
			,   data_itemid = targetElement.attr('data-item-id') 
			,   data_product_group = targetElement.attr('data-product-group') 
			//console.log(data_product_group)

			var Configuration = this.configuration;
			var savedsearchConfiguration = Configuration.PDPInventorySavedSearches
			,   savedsearchConfigurationConfig = savedsearchConfiguration.config
			//console.log(savedsearchConfigurationConfig)

			var findProductGroup = _.findWhere(savedsearchConfigurationConfig, {
                    productgroup: data_product_group
                });

			//console.log(findProductGroup.savedsearchid)
			if(findProductGroup){
				//var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1200&deploy=1&compid=4953269&h=3ad6824db9f8a7d9bc2e&savedsearch="+findProductGroup.savedsearchid;
				var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1200&deploy=1&compid=4953269&ns-at=AAEJ7tMQKfqLjRahcWz4zrvJIqk3zhCzsrY5yIVUdL6M-UEq0AY&savedsearch="+findProductGroup.savedsearchid;
				window.location.href = url;
			}
			
		}	

	,   takeToViewInventoryPage: function takeToViewInventoryPage(e)
		{
			var targetElement = $(e.currentTarget)
			,   data_productgroup = targetElement.attr('data-product-group');

			//console.log(data_productgroup) 
			if(data_productgroup){
			var url = '/inventory-page?group='+data_productgroup;
			window.open(url, '_blank');
			}
		}	

		//@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
	,	getContext: function getContext()
		{
			//console.log(this.specificationItemFields)
			
			var item_info = this.iteminfo
			,   resourcesArray =  []
			,   item = item_info.item
			,   product_group = item.custitemproduct_category
			,   featured_desc = item.featureddescription

			,   customSpecificiations = item.custitem110
			,   showCustomSpecificiations = false


			,   newResource1 = item.custitem_resource1_new
			,   newResource1Thumb = item.custitem_resource_1_thumbnail_new
			,   newResource2 = item.custitem_resource2_new
			,   newResource2Thumb = item.custitem_resource_2_thumbnail_new
			,   newResource3 = item.custitem_resource3_new
			,   newResource3Thumb = item.custitem_resource_3_thumbnail_new


			var hideDocuments = true;

			/*if(resources1Value || resources2Value || resources3Value || resources4Value || resources5Value || resources6Value || resources7Value || resources8Value || resources9Value || resources10Value)
			{
				hideDocuments = false;
			}*/

			//console.log(item)
			if(newResource1 || newResource2 || newResource3)
			{
				hideDocuments = false;
			}

			if(newResource1){
				resourcesArray.push({
					//'name' : resources1Label ? resources1Label.split('.')[0] : '',
					'url' : newResource1,
					'img' : newResource1Thumb
				});
			}

			if(newResource2){
				resourcesArray.push({
					//'name' : resources1Label ? resources1Label.split('.')[0] : '',
					'url' : newResource2,
					'img' : newResource2Thumb
				});
			}

			if(newResource3){
				resourcesArray.push({
					//'name' : resources1Label ? resources1Label.split('.')[0] : '',
					'url' : newResource3,
					'img' : newResource3Thumb
				});
			}

			/*if(resources1Value){
				resourcesArray.push({
					'name' : resources1Label ? resources1Label.split('.')[0] : '',
					'url' : resources1Value,
					'img' : resources1Img
				});
			}
			if(resources2Value){
				resourcesArray.push({
					'name' : resources2Label ? resources2Label.split('.')[0] : '',
					'url' : resources2Value,
					'img' : resources2Img
				});
			}
			if(resources3Value){
				resourcesArray.push({
					'name' : resources3Label ? resources3Label.split('.')[0] : '',
					'url' : resources3Value,
					'img' : resources3Img
				});
			}
			if(resources4Value){
				resourcesArray.push({
					'name' : resources4Label ? resources4Label.split('.')[0] : '',
					'url' : resources4Value,
					'img' : resources4Img
				});
			}
			if(resources5Value){
				resourcesArray.push({
					'name' : resources5Label ? resources5Label.split('.')[0] : '',
					'url' : resources5Value,
					'img' : resources5Img
				});
			}
			if(resources6Value){
				resourcesArray.push({
					'name' : resources6Label ? resources6Label.split('.')[0] : '',
					'url' : resources6Value,
					'img' : resources6Img
				});
			}
			if(resources7Value){
				resourcesArray.push({
					'name' : resources7Label ? resources7Label.split('.')[0] : '',
					'url' : resources7Value,
					'img' : resources7Img
				});
			}
			if(resources8Value){
				resourcesArray.push({
					'name' : resources8Label ? resources8Label.split('.')[0] : '',
					'url' : resources8Value,
					'img' : resources8Img
				});
			}
			if(resources9Value){
				resourcesArray.push({
					'name' : resources9Label ? resources9Label.split('.')[0] : '',
					'url' : resources9Value,
					'img' : resources9Img
				});
			}
			if(resources10Value){
				resourcesArray.push({
					'name' : resources10Label ? resources10Label.split('.')[0] : '',
					'url' : resources10Value,
					'img' : resources10Img
				});
			}*/

			//console.log(item)

			var media1 = item.custitemcustitem_media1
			,   media2 = item.custitemcustitem_media2
			,   media3 = item.custitemcustitem_media3
			,   media4 = item.custitemcustitem_media4
			,   mediaArray =  []
			,   hideMedia = true

			if(media1 || media2 || media3 || media4)
			{
				hideMedia = false;
			}

			if(media1){
				mediaArray.push({
					'value' : media1
				});
			}
			if(media2){
				mediaArray.push({
					'value' : media2
				});
			}
			if(media3){
				mediaArray.push({
					'value' : media3
				});
			}
			if(media4){
				mediaArray.push({
					'value' : media4
				});
			}

			var crosssellitems = this.crosssellitems;

			var itemType = item.itemtype;

			var componentsData = this.itemComponentsData;
			var kitComponentsData = this.kitItemComponentsData;

			//console.log(resources1Img)

			var specificationFieldsLength =  this.specificationItemFields

			this.resourcesArray = resourcesArray;
			this.mediaArray = mediaArray;

			if(customSpecificiations)
			showCustomSpecificiations = true;	
			//var str="hello world !#to&you%*()";
			//console.log(featured_desc.replace(/[_\W]+/g, " "));
			//console.log(featured_desc)
			return {
				productGroup : product_group,
				productGroupImageURL : "img/Product Group Icons/"+product_group+".svg",
				shopProductGroup : (product_group !== '&nbsp;' && product_group !== '') ? true : false,
				featuredDesc : featured_desc/*featured_desc.replace(/[_\W]+/g, " ")*/,
				displayName : item.displayname,
				itemId : item.internalid,
				hideDocuments : hideDocuments,
				hideMedia : hideMedia,
				hideResources : hideDocuments && hideMedia,
				resourcesArray : resourcesArray,
				showLessResources : resourcesArray && resourcesArray.length > 3 ? true : false,
				mediaArray: mediaArray,
				showLessMedia : mediaArray && mediaArray.length > 1 ? true : false,
				DisplayCrossSellSection : crosssellitems && crosssellitems.length > 0 ? true : false,
				InvtItemType : (itemType === "InvtPart" &&  componentsData.length > 0) ? true : false,
				KitItemType : (itemType === "Kit" &&  kitComponentsData.length > 0) ? true : false,
				specificationFields : this.specificationItemFields,
				showLessSpecfications : specificationFieldsLength && specificationFieldsLength.length > 4 ? true : false,
				kitComponentsData : kitComponentsData,
				showLessKit : kitComponentsData && kitComponentsData.length >= 2 ? true : false,
				isPhoneDevice : Utils.isPhoneDevice(),
				showCustomSpecificiations : showCustomSpecificiations,
				customSpecificiations : customSpecificiations
			};
		}
	});
});
